import styled from 'styled-components';

export const ApplicationSectionMStyled = styled(`section`)`
	display: none;
	margin: 0 16px;
	width: calc(100vw - 32px);
	@media (max-width: 575px) {
		display: block;
	}
`;
